import { action } from "satcheljs";

/**
 * Triggers handler for rendering an accessibility alert message using focus-based announcement.
 * This is specifically for VoiceOver support in iframes where aria-live regions may not be detected.
 */
export default action(
    "FIRE_FOCUSED_BASED_ACCESSIBILITY_ALERT",
    (
        alertText: string
    ) => ({
        alertText: alertText
    })
);
